import React from 'react';
import { motion } from 'framer-motion';
const timeline = [{
  time: '4:00 PM',
  title: 'Arrival & Vibes',
  desc: 'Music. Light bites. Intention.'
}, {
  time: '4:20 PM',
  title: 'Leadership & Partners Address',
  desc: 'Opening remarks from leadership and partners setting the vision for the evening.'
}, {
  time: '4:30 PM',
  title: 'Investor Insights Panel',
  desc: 'What makes them write a cheque. What founders get wrong. What makes a pitch unforgettable.'
}, {
  time: '5:00 PM',
  title: 'Speed Investor Matching',
  desc: '5–7 minute rapid-fire meetings. Curated rotations. Direct fundraising conversations.'
}, {
  time: '6:15 PM',
  title: '2-Minute Stage Pitch',
  desc: 'Clear problem. Big vision. Strong traction. Direct ask.'
}, {
  time: '7:15 PM',
  title: 'Open Networking & Celebration',
  desc: 'Follow-ups begin. Conversations deepen. Deals start forming.'
}];
export function InvestorAgenda() {
  return <section className="mb-12 md:mb-16" data-id="element-166">
      <div className="flex items-center mb-6 md:mb-8" data-id="element-167">
        <span className="w-8 md:w-12 h-[1px] md:h-[2px] bg-accent-cyan mr-4" data-id="element-168"></span>
        <h2 className="font-sora font-semibold text-lg md:text-2xl text-white" data-id="element-169">
          Event Schedule
        </h2>
      </div>

      <div className="relative pl-6 md:pl-8 border-l border-white/10 lg:border-none lg:pl-0 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-6" data-id="element-170">
        {timeline.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        delay: index * 0.1
      }} className="relative lg:bg-white/5 lg:border lg:border-white/10 lg:rounded-2xl lg:p-6 lg:hover:bg-white/10 lg:transition-colors" data-id="element-171">
            {/* Glowing dot - only visible on mobile/tablet where the vertical line exists */}
            <div className="absolute -left-[29px] md:-left-[37px] lg:hidden top-1.5 md:top-2 w-3 h-3 md:w-4 md:h-4 rounded-full bg-accent-cyan shadow-[0_0_10px_rgba(79,195,247,0.8)] border-2 border-[#0a0e27]" data-id="element-172" />

            <div className="glass-card rounded-xl p-4 md:p-6 lg:p-0 lg:bg-transparent lg:border-none lg:shadow-none lg:backdrop-blur-none" data-id="element-173">
              <span className="font-sora text-xs md:text-sm lg:text-base font-bold text-accent-cyan tracking-wider mb-1 md:mb-2 block" data-id="element-174">
                {item.time}
              </span>
              <h4 className="font-sora font-semibold text-white md:text-xl mb-2" data-id="element-175">
                {item.title}
              </h4>
              <p className="font-inter text-sm md:text-base lg:text-lg text-white/70" data-id="element-176">
                {item.desc}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}